<span>{{ countryCode === 'US' ? countries.US.regions[regionCode] : regionCode }}</span>
